import { useMutation } from '@apollo/client/react'
import Router from 'next/router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbars } from 'settle-ui/hooks/useSnackbars/useSnackbars'
import { RouterPage } from 'lib/navigation/consts'
import { isApolloErrorWithCode } from 'lib/helpers/isApolloErrorWithCode/isApolloErrorWithCode'
import {
  UpdatePayerInvitationHookDocument,
  type UpdatePayerInvitationHookVariables,
} from './useUpdatePayerInvitation.graphql'

interface Params {
  onSuccess?: () => void
}

export const useUpdatePayerInvitation = ({ onSuccess }: Params = {}) => {
  const { t } = useTranslation()
  const { showError, showApolloOrTextError } = useSnackbars()
  const [loading, setLoading] = useState(false)
  const [mutate] = useMutation(UpdatePayerInvitationHookDocument)

  const updatePayerInvitation = async (variables: UpdatePayerInvitationHookVariables) => {
    try {
      setLoading(true)

      await mutate({ variables })
      await onSuccess?.()
      setLoading(false)
    } catch (err) {
      if (isApolloErrorWithCode(err, { code: 'business_exists' })) {
        Router.push({ pathname: RouterPage.login })
        showError(t('onboarding::validation::businessExists'))
      } else {
        showApolloOrTextError(err, t('somethingWentWrong'))
      }
    } finally {
      setLoading(false)
    }
  }

  return {
    updatePayerInvitation,
    loading,
  }
}
